import { getSasToken } from '../config.service';
import { PointCloudEptGeometry, PointCloudEptGeometryNode } from './ept-geometry';

function appendSasToken(url: string): string {
  const token = getSasToken();
  if (!token) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${token}`;
}

export class EptLoader {
  /**
   * Load an EPT point cloud from an ept.json URL.
   * @param file - URL to ept.json
   * @param signal - Optional AbortSignal for cancellation
   */
  static async load(file: string, signal?: AbortSignal): Promise<any> {
    const response = await fetch(appendSasToken(file), { signal });
    const json = await response.json();

    const url = file.substring(0, file.lastIndexOf('/ept.json'));
    const geometry = new PointCloudEptGeometry(url, json);
    const root = new PointCloudEptGeometryNode(geometry);

    geometry.root = root;
    root.load();

    return geometry;
  }
}
